import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on Mon Feb 18 2019
 * @author SKu
 * @author Tomas Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { jsonConversions, ResourceLockDTOConverter, ResourceLockResultDTOConverter } from '@logio/common-be-fe';
import { Inject } from '@logio/typescript-ioc';
import { Map as IMap } from 'immutable';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import logger from '../../logger';
export var ResourceLockLayer =
/*#__PURE__*/
function () {
  function ResourceLockLayer() {
    var _this = this;

    _classCallCheck(this, ResourceLockLayer);

    /**
     * Fetches all locked resources for required type
     *
     * @param {ResourceLockType} resourceLockType
     */
    this.findLockedResources = function (resourceLockType) {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var apiConfig;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apiConfig = {
                  responseType: 'json'
                };
                _context.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.RESOURCE_LOCK).post({
                  resourceLockType: resourceLockType
                }, apiConfig).then(function (response) {
                  var map = IMap();
                  (response.data.result || []).map(function (item) {
                    var lock = _this2.getConverter().toObject(item, jsonConversions);

                    map.set(lock.resourceId, lock);
                  });
                  return map;
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                });

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    };
    /**
     * Lock resourceId for specific user
     *
     * @param {string} resourceId
     * @param {ResourceLockType} resourceLockType
     */


    this.lockResource = function (resourceId, resourceLockType) {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var apiConfig;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                apiConfig = {
                  responseType: 'json'
                };
                _context2.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.RESOURCE_LOCK_LOCK(resourceId)).post({
                  resourceLockType: resourceLockType
                }, apiConfig).then(function (response) {
                  return _this3.getResultConverter().toObject(response.data.result, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                });

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    };
    /**
     * Unlock resourceId for specific user
     *
     * @param {string} resourceId
     * @param {ResourceLockType} resourceLockType
     */


    this.unlockResource = function (resourceId, resourceLockType) {
      return __awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        var apiConfig;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                apiConfig = {
                  responseType: 'json'
                };
                _context3.next = 3;
                return api(CONSTANTS.API.ENDPOINTS.RESOURCE_LOCK_UNLOCK(resourceId)).post({
                  resourceLockType: resourceLockType
                }, apiConfig).then(function (response) {
                  return _this4.getResultConverter().toObject(response.data.result, jsonConversions);
                }).catch(function (error) {
                  logger.error(error);
                  return Promise.reject(error);
                });

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    };
  }

  _createClass(ResourceLockLayer, [{
    key: "getConverter",
    value: function getConverter() {
      return this.converter;
    }
  }, {
    key: "getResultConverter",
    value: function getResultConverter() {
      return this.resultConverter;
    }
  }]);

  return ResourceLockLayer;
}();

__decorate([Inject, __metadata("design:type", ResourceLockDTOConverter)], ResourceLockLayer.prototype, "converter", void 0);

__decorate([Inject, __metadata("design:type", ResourceLockResultDTOConverter)], ResourceLockLayer.prototype, "resultConverter", void 0);